<template>
  <rect width="24" height="24" rx="12" fill="#1D8DB5" />
  <path
    d="M15.3845 20.3077L16.6153 19.0769L14.7692 11.0769L18.1538 7.69231C18.6645 7.18154 18.6645 6.35692 18.1538 5.84615C17.643 5.33538 16.8184 5.33538 16.3076 5.84615L12.923 9.23077L4.923 7.38461L3.69223 8.61538L10.1538 12L6.76916 15.3846L4.61531 15.0769L3.69223 16L6.46146 17.5385L7.99993 20.3077L8.923 19.3846L8.61531 17.2308L11.9999 13.8462L15.3845 20.3077Z"
    fill="white"
  />
</template>
